import i18next from "i18next";
import { ptBR, enUS, es } from 'date-fns/locale';

export const getFormattedLanguage = (
  language: string = i18next.language
): string => {
  if (language === 'pt-BR') return 'pt';
  if (language === 'en-US') return 'en';
  if (language === 'es-ES') return 'es';
  return 'en';
};


export const getLocale = () => {
  const language = i18next.language.toLowerCase();
  if (language.startsWith('pt')) return ptBR;
  if (language.startsWith('es')) return es;
  return enUS;
};
